import script from "./EditLabelMixin.vue?vue&type=script&lang=js"
export * from "./EditLabelMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__